// extracted by mini-css-extract-plugin
module.exports = {"container":"weather_container__Hb3Qw","weather":"weather_weather__i-B98","date":"weather_date__26VYW","time":"weather_time____vQU"};